export const createModeModal = () => {
    const modalOverlay = document.createElement("div");
    modalOverlay.id = "mode-change-modal";
    modalOverlay.innerHTML = `
        <div class="mode-modal-backdrop">
            <div class="mode-modal-content">
                <h3>Cambio de Modo</h3>
                <p id="mode-modal-text">
                <strong>Modo Global:</strong> todos ven lo mismo y tus cambios se comparten.<br><br>
                <strong>Modo Local:</strong> solo tú ves tus cambios, nadie más.<br><br>
                <strong>Tu trabajo se guarda siempre</strong> — al cambiar de modo no pierdes nada, pero en local no afectas al proyecto de los demás.</p>
                <label class="mode-modal-checkbox">
                    <input type="checkbox" id="mode-modal-dont-show">
                    <span>No volver a mostrar</span>
                </label>
                <div class="mode-modal-buttons">
                    <button id="mode-modal-confirm">Continuar</button>
                </div>
            </div>
        </div>
    `;

    const modalStyles = document.createElement("style");
    modalStyles.textContent = `
        .mode-modal-backdrop {
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0,0,0,0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        }
        .mode-modal-content {
            background: white;
            border-radius: 12px;
            padding: 24px;
            max-width: 400px;
            width: 90%;
            box-shadow: 0 10px 40px rgba(0,0,0,0.2);
            animation: modalPop 0.2s ease;
        }
        @keyframes modalPop {
            from { transform: scale(0.9); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
        }
        .mode-modal-content h3 { margin: 0 0 12px 0; color: #333; font-size: 18px; }
        .mode-modal-content p { margin: 0 0 20px 0; color: #666; font-size: 14px; line-height: 1.5; }
        .mode-modal-checkbox {
            display: flex; align-items: center; gap: 8px;
            margin-bottom: 20px; font-size: 13px; color: #555; cursor: pointer;
        }
        .mode-modal-checkbox input { width: 16px; height: 16px; cursor: pointer; }
        .mode-modal-buttons { display: flex; justify-content: flex-end; gap: 10px; }
        .mode-modal-buttons button {
            padding: 8px 16px; border-radius: 6px; border: none;
            font-size: 14px; cursor: pointer; transition: all 0.15s;
        }
        #mode-modal-confirm { background: #4d97ff; color: white; }
        #mode-modal-confirm:hover { background: #3a7de0; }
    `;

    document.head.appendChild(modalStyles);
    return modalOverlay;
};

export const shouldSkipModal = () => {
    return localStorage.getItem("modeChangeModalSkip") === "true";
};

export const showModeModal = (modalOverlay, onConfirm) => {
    const checkbox = modalOverlay.querySelector("#mode-modal-dont-show");
    checkbox.checked = false;

    document.body.appendChild(modalOverlay);
    const confirmBtn = modalOverlay.querySelector("#mode-modal-confirm");

    const cleanup = () => {
        modalOverlay.remove();
        confirmBtn.removeEventListener("click", onConfirmClick);
    };

    const onConfirmClick = () => {
        if (checkbox.checked) {
            localStorage.setItem("modeChangeModalSkip", "true");
        }
        cleanup();
        onConfirm();
    };

    confirmBtn.addEventListener("click", onConfirmClick);
};
